import {
    SET_SELECTED_CAMPAIGN,
    SET_SELECTED_CAMPAIGN_ID,
    TOP_CONTRIBUTORS_REQUESTED,
    TOP_CONTRIBUTORS_SUCCEEDED,
    TOP_CONTRIBUTORS_FAILED,
    TOP_TAGS_REQUESTED,
    TOP_TAGS_SUCCEEDED,
    TOP_TAGS_FAILED,
    SET_SELECTED_SEGMENT,
    IMPACT_FILTER_REQUESTED,
    IMPACT_FILTER_SUCCEEDED,
    IMPACT_FILTER_FAILED,
    SPECIFIC_CAMPAIGN_REQUESTED,
    SPECIFIC_CAMPAIGN_SUCCEEDED,
    SPECIFIC_CAMPAIGN_FAILED,
    CONNECTED_CAMPAIGN_REQUESTED,
    CONNECTED_CAMPAIGN_SUCCEEDED,
    CONNECTED_CAMPAIGN_FAILED,
    SET_PARENT_CAMPAIGN,
} from './constants';

const initialState = {
    // initialize empty array for top contributiors
    topContributors: [],
    // initialize boolean to represent topContributors loading state
    contributorsLoading: false,
    // initialize empty arrays for user and ml generated top tags
    topTags: { mlTags: [], userTags: [] },
    // initialize boolean to represent topTags loading state
    tagsLoading: false,
    // initialize integer value for total tags
    totalTags: 0,
    // initialize empty string for selected taxonomy
    taxonomy: '',
    // initialize empty string for selected date
    date: '',
    // initialize empty array for segment tags
    segmentTags: { mlTags: [], userTags: [] },
    // initialize value for total segment tags
    segmentTotalTags: 0,
    // initial state of segment to fetch segment tags for
    segmentId: null,
    // initialize boolean to represent segment tags loading state
    segmentTagsLoading: false,
    // intialize empty string for selected taxonomy in segment tags
    segmentTaxonomy: 'category',
    // initial state of challenge to fetch segments for
    challengeId: null,
    // Limits the number of segments being fetched
    segmentsLimit: 10,
    // initial state of error
    error: null,
    // denotes the selected challenge
    challenge: {},
    // challenge loading state
    challengeRequested: false,
    // denotes the currently selected impact box filter radio option
    selectedFilter: null,
    // The litters to be shown on map
    impactLitters: [],
    // indicates whether the litters have been requested or not
    litterRequested: true,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case SET_SELECTED_CAMPAIGN_ID: {
            const { challengeId } = action;
            return {
                ...state,
                challengeId,
            };
        }
        case SET_SELECTED_CAMPAIGN: {
            const { challenge } = action;
            return {
                ...state,
                challenge,
            };
        }
        case SET_SELECTED_SEGMENT: {
            const { segmentId } = action;
            return { ...state, segmentId };
        }
        case TOP_CONTRIBUTORS_REQUESTED: {
            const { date, customDate } = action;
            return {
                ...state,
                date,
                customDate,
                contributorsLoading: true,
            };
        }
        case TOP_CONTRIBUTORS_SUCCEEDED: {
            const { topContributors } = action;
            return {
                ...state,
                topContributors,
                contributorsLoading: false,
            };
        }
        case TOP_CONTRIBUTORS_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                contributorsLoading: false,
            };
        }
        case TOP_TAGS_REQUESTED: {
            const { taxonomy } = action;
            return {
                ...state,
                taxonomy,
                tagsLoading: true,
            };
        }
        case TOP_TAGS_SUCCEEDED: {
            const { topTags } = action;
            return {
                ...state,
                ...topTags,
                tagsLoading: false,
            };
        }
        case TOP_TAGS_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                tagsLoading: false,
            };
        }
        case IMPACT_FILTER_REQUESTED: {
            const { selectedFilter } = action;
            return {
                ...state,
                selectedFilter,
                litterRequested: true,
            };
        }
        case IMPACT_FILTER_SUCCEEDED: {
            const { impactLitters } = action;
            return {
                ...state,
                litterRequested: false,
                impactLitters,
            };
        }
        case IMPACT_FILTER_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                litterRequested: false,
            };
        }
        case SPECIFIC_CAMPAIGN_REQUESTED: {
            const { challengeId } = action;
            return {
                ...state,
                challengeId,
                challengeRequested: true,
            };
        }
        case SPECIFIC_CAMPAIGN_SUCCEEDED: {
            const { challenge } = action;
            return {
                ...state,
                challengeRequested: false,
                challenge,
            };
        }
        case SPECIFIC_CAMPAIGN_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                challengeRequested: false,
            };
        }
        case CONNECTED_CAMPAIGN_REQUESTED: {
            return {
                ...state,
                connectedChallengesLoading: true,
            };
        }
        case CONNECTED_CAMPAIGN_SUCCEEDED: {
            const { challenges } = action;
            return {
                ...state,
                connectedChallengesLoading: false,
                connectedChallenges: challenges,
            };
        }
        case CONNECTED_CAMPAIGN_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                connectedChallengesLoading: false,
            };
        }
        case SET_PARENT_CAMPAIGN: {
            const { parentChallenge } = action;
            return {
                ...state,
                parentChallenge,
            };
        }
        default:
            return state;
    }
}
